function isWebRTCSupported(): boolean {
  let isWebRTCSupported = false;
  ["RTCPeerConnection", "webkitRTCPeerConnection", "mozRTCPeerConnection", "RTCIceGatherer"].forEach(item => {
    if (isWebRTCSupported) return;
    if (item in window) isWebRTCSupported = true;
  });
  return isWebRTCSupported;
}

function isGetUserMediaSupported(): boolean {
  return navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === "function";
}

export { isWebRTCSupported, isGetUserMediaSupported };
